import React, { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bot, Send, Sparkles } from "lucide-react";

const EXAMPLES = [
  "今月家賃が入っていない入居者を表示",
  "来月契約更新になる人を表示",
  "空室一覧を表示",
  "修繕費が高い物件をランキング",
  "今月の利益はいくら？",
  "一番利益率が高い物件はどれ？",
  "この物件を買うべきか分析",
  "督促文を作成",
  "オーナー報告書を作成",
];

export default function AIAssistant() {
  const [messages, setMessages] = useState([
    { role: "assistant", text: "こんにちは。Neo Estate AIアシスタントです。物件・入居者・収支に関するご質問にお答えします。（※AIモデル接続はPhaseIII で有効化されます）" },
  ]);
  const [input, setInput] = useState("");

  const send = (text) => {
    const t = text || input;
    if (!t.trim()) return;
    setMessages((m) => [...m, { role: "user", text: t },
      { role: "assistant", text: "現在AIモデルは未接続です（PhaseIII で GPT / Claude / Gemini を選択して有効化予定）。データ変更を伴う操作は「提案 → ユーザー承認 → API実行」の順で安全に実行される設計です。" }]);
    setInput("");
  };

  return (
    <div className="animate-fade-in h-full flex flex-col">
      <PageHeader
        title="AIアシスタント"
        subtitle="自然な日本語で物件データを問い合わせ（Phase 3で有効化）"
        actions={<span className="text-xs bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-sm">AIモデル未接続</span>}
      />

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-6 min-h-0">
        <div className="lg:col-span-2 bg-white border border-border rounded-sm flex flex-col">
          <div className="flex-1 overflow-y-auto p-5 space-y-4">
            {messages.map((m, i) => (
              <div key={i} className={`flex gap-3 ${m.role === "user" ? "flex-row-reverse" : ""}`}>
                <div className={`w-8 h-8 rounded-sm flex items-center justify-center shrink-0 ${m.role === "user" ? "bg-[#111]" : "bg-brand"}`}>
                  {m.role === "user" ? <span className="text-white text-xs">You</span> : <Bot className="w-4 h-4 text-white" />}
                </div>
                <div className={`max-w-[75%] px-4 py-2.5 rounded-sm text-sm ${m.role === "user" ? "bg-[#111] text-white" : "bg-gray-100 text-[#0A0A0A]"}`}>
                  {m.text}
                </div>
              </div>
            ))}
          </div>
          <div className="border-t border-border p-3 flex gap-2">
            <Input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="質問を入力..." data-testid="ai-input" />
            <Button onClick={() => send()} className="bg-brand hover:bg-brand-hover text-white" data-testid="ai-send"><Send className="w-4 h-4" /></Button>
          </div>
        </div>

        <div className="bg-white border border-border rounded-sm p-5">
          <h3 className="text-sm font-medium mb-3 flex items-center gap-2"><Sparkles className="w-4 h-4 text-brand" />質問例</h3>
          <div className="space-y-2">
            {EXAMPLES.map((ex, i) => (
              <button key={i} onClick={() => send(ex)}
                className="w-full text-left text-sm px-3 py-2 rounded-sm border border-border hover:border-brand/60 hover:bg-gray-50 transition-colors" data-testid={`ai-example-${i}`}>
                {ex}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
